// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bd-0";
export var orangeButton = "_bd-1";